import { TAXDOWN_ASSETS_DOMAIN } from 'Constants/domains';

export const ImageByResult = {
  0: `${TAXDOWN_ASSETS_DOMAIN}/quiz/ajolote_0.svg`,
  1: `${TAXDOWN_ASSETS_DOMAIN}/quiz/ajolote_1.svg`,
  2: `${TAXDOWN_ASSETS_DOMAIN}/quiz/ajolote_2.svg`,
  3: `${TAXDOWN_ASSETS_DOMAIN}/quiz/ajolote_3.svg`,
  4: `${TAXDOWN_ASSETS_DOMAIN}/quiz/ajolote_4.svg`,
  5: `${TAXDOWN_ASSETS_DOMAIN}/quiz/ajolote_5.svg`,
  6: `${TAXDOWN_ASSETS_DOMAIN}/quiz/ajolote_5.svg`,
};
